export const SEASON_TYPES = {
  SINGLE_YEAR: "single-year",
  CROSS_YEAR: "cross-year",
} as const;

export type TSeasonType = (typeof SEASON_TYPES)[keyof typeof SEASON_TYPES];
